import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/React-Components/React-Components/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from "docz";
import Layout from "../components/Layout";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "layout"
    }}>{`Layout`}</h1>
    <Props of={Layout} mdxType="Props" />
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={1} __code={'<Layout\n  firebaseConfig={{\n    apiKey: \'AIzaSyBxBIbTYbRuqP1np-ri4YaJ0H6OYK4L46g\',\n    authDomain: \'upe-website-fa07a.firebaseapp.com\',\n    databaseURL: \'https://upe-website-fa07a.firebaseio.com\',\n    projectId: \'upe-website-fa07a\',\n    storageBucket: \'upe-website-fa07a.appspot.com\',\n    messagingSenderId: \'896060764020\',\n    appId: \'1:896060764020:web:331114a396e41adfa30621\',\n    measurementId: \'G-BV6VQMMSQ5\',\n  }}\n>\n  <h1>Hello World!</h1>\n</Layout>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Layout,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Layout firebaseConfig={{
        apiKey: "AIzaSyBxBIbTYbRuqP1np-ri4YaJ0H6OYK4L46g",
        authDomain: "upe-website-fa07a.firebaseapp.com",
        databaseURL: "https://upe-website-fa07a.firebaseio.com",
        projectId: "upe-website-fa07a",
        storageBucket: "upe-website-fa07a.appspot.com",
        messagingSenderId: "896060764020",
        appId: "1:896060764020:web:331114a396e41adfa30621",
        measurementId: "G-BV6VQMMSQ5"
      }} mdxType="Layout">
    <h1>Hello World!</h1>
  </Layout>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      